<div class="flip-card" [ngClass]="flipForward ? 'forward' : 'backward'" (click)="returnCard()">
  <div class="flip-card-inner">
    <!-- image de face -->
    <div class="flip-card-front">
       <!-- Icon Valide -->
      <div class="absolute top-0 left-0 z-1 hide--icon" [class.show--icon]="!card.isCardReturned && card.isCardToFind" *ngIf="card.isCardToFind && isGameReadyToPlay">
        <img src="images/memoryCardGame/validIcon.svg">
      </div>
      <div class="image__container relative">
        <img [src]="frontImageNameUrl">
      </div>
    </div>
    <!-- imge de derriere -->
    <div class="flip-card-back">
      <img [src]="backImageNameUrl">
    </div>
  </div>
</div>
